import { TSuggest } from 'feature/registration/types'
import { debounce } from 'helpers/debounce'
import { isLkmDomain } from 'router/utils'
import { sendRequestNoAuth } from 'transport/sendRequestNoAuth'
import { sendRequestWithAuth } from 'transport/sendRequestWithAuth'

// получение подсказок Dadata по введенным данным
export const getSuggestsQuery = async (query: string, signal?: AbortSignal) => {
  const isLkm = isLkmDomain()
  const url = isLkm
    ? 'v1/fitter/dadata/address/suggest'
    : '/v1/dadata/address/suggest'

  const sendRequest = isLkm ? sendRequestWithAuth : sendRequestNoAuth

  const res = await sendRequest.post<TSuggest[]>(
    url,
    {
      query,
    },
    { signal },
  )

  if (res && res.data) {
    const dataWithAddress = res.data.map(item => ({
      ...item,
      //@ts-ignore
      address: item.value,
    }))

    return { ...res, data: dataWithAddress }
  }

  return res
}

export const debouncedGetSuggestsQuery = debounce(getSuggestsQuery, 300)
